export default "__VITE_ASSET__DsHuyBuY__"